/* eslint-disable no-alert */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import Pagination from 'material-ui-flat-pagination';
import PostFileDelete, {
  SendRequestDto as SendDeleteRequestDto,
} from '../../../api/FileDeleteAPI';
import { SendRequestDto } from '../../../api/PushSendAPI';
import { defaultChehckedCity } from '../../../models/municipality';
import GetFileList from '../../../api/FileListAPI';
import { FileInfo } from '../../../models/file';
import {
  ERROR_MESSAGE_API,
  FILE_LIST_INDEX_TEXT,
  FILE_DATETIME_TEXT,
  FILE_NAME_TEXT,
  FILE_SPACE_TEXT,
  NOTIFICATION,
  DELETE,
  DEVICE_TYPE_ANDROID_CODE,
  DEVICE_TYPE_IOS_CODE,
  NOTIFICATION_TYPE_2_CODE,
  API_URL,
  RUNNING_TYPE,
  RUNNING_TYPE_MASTER,
  RUNNING_TYPE_DEVELOP,
  RUNNING_TYPE_LOCAL,
  API_DEV_URL,
  API_LOCAL_URL,
  UPLOAD,
} from '../../../util/Const';
import FileSelect from './FormItem';
import { GetTimestampForNumber } from '../GenericMethod';
import PostFileUpload from '../../../api/FileUploadAPI';

const FileListIndex = (props: any) => {
  const { history } = props;
  const [fileListIndex, setFileIndex] = useState<FileInfo[]>([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [file, setFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState<String>('');
  // 初期オフセット0
  const [offset, setOffset] = useState(0);
  // 1ページの最大表示
  const parPage = 10;

  const handleClickPagination = (currentOffset: any) => {
    setOffset(currentOffset);
  };

  const fileDelete = async (filename: String) => {
    const result = confirm(`${filename}を削除します。`);
    if (result) {
      const request: SendDeleteRequestDto = {
        id: sessionStorage.getItem('id'),
        fileName: filename,
      };
      try {
        await PostFileDelete(request).then(() => {
          setOffset(0);
          setRefreshKey(refreshKey + 1);
        });
      } catch (error) {
        alert(ERROR_MESSAGE_API);
      }
    }
  };

  const handleClickNotificationBtn = (filename: String) => {
    let url: string;
    switch (RUNNING_TYPE) {
      case RUNNING_TYPE_MASTER:
        url = `${API_URL}/files/${sessionStorage.getItem('id')}/${filename}`;
        break;
      case RUNNING_TYPE_DEVELOP:
        url = `${API_DEV_URL}/files/${sessionStorage.getItem(
          'id'
        )}/${filename}`;
        break;
      case RUNNING_TYPE_LOCAL:
        url = `${API_LOCAL_URL}/files/${sessionStorage.getItem(
          'id'
        )}/${filename}`;
        break;
      default:
        url = `${API_DEV_URL}/files/${sessionStorage.getItem(
          'id'
        )}/${filename}`;
        break;
    }
    const request: SendRequestDto = {
      title: '',
      message: '',
      author: sessionStorage.getItem('name'),
      device: [DEVICE_TYPE_ANDROID_CODE, DEVICE_TYPE_IOS_CODE],
      target: defaultChehckedCity(),
      url,
      type: NOTIFICATION_TYPE_2_CODE,
      is_debug: 0,
    };
    history.push({ pathname: '/PushSend', state: request });
  };

  const open = (filename: String) => {
    console.info(filename);
    let url: string;
    switch (RUNNING_TYPE) {
      case RUNNING_TYPE_MASTER:
        url = `${API_URL}/files/${sessionStorage.getItem('id')}/${filename}`;
        break;
      case RUNNING_TYPE_DEVELOP:
        url = `${API_DEV_URL}/files/${sessionStorage.getItem(
          'id'
        )}/${filename}`;
        break;
      case RUNNING_TYPE_LOCAL:
        url = `${API_LOCAL_URL}/files/${sessionStorage.getItem(
          'id'
        )}/${filename}`;
        break;
      default:
        url = 'https://example.com';
        break;
    }
    window.open(url);
  };

  const onClickSubmit = async () => {
    if (!file) {
      alert('ファイルが選択されていません。');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', sessionStorage.getItem('id')!!);

    try {
      await PostFileUpload(formData).then(() => {
        alert('ファイルのアップロードが完了しました。');
        setFile(null);
        setFileName('');
        setOffset(0);
        setRefreshKey(refreshKey + 1);
      });
    } catch (error) {
      alert(ERROR_MESSAGE_API);
    }
  };

  useEffect(() => {
    const f = async () => {
      await GetFileList()
        .then((response) => {
          const list: FileInfo[] = [];
          for (const fileItem of response.files) {
            const files: FileInfo = {
              name: fileItem.name,
              timestamp: fileItem.timestamp,
            };
            list.push(files);
          }
          setFileIndex(list);
        })
        .catch(() => {
          alert(ERROR_MESSAGE_API);
        });
    };
    f();
  }, [refreshKey]);

  if (!history) {
    return null;
  }
  const indexItem = fileListIndex
    .slice(offset, offset + parPage)
    .map((fileItem: FileInfo) => {
      return (
        <tr key={fileItem.name} className="index">
          <td className="title">
            <button
              type="button"
              className="btn_back"
              onClick={() => open(fileItem.name)}
            >
              {fileItem.name}
            </button>
          </td>
          <td>{GetTimestampForNumber(fileItem.timestamp)}</td>
          <td>
            <button
              type="button"
              className="btn_back"
              onClick={() => handleClickNotificationBtn(fileItem.name)}
            >
              {NOTIFICATION}
            </button>
            <button
              type="button"
              className="btn_back"
              onClick={() => fileDelete(fileItem.name)}
            >
              {DELETE}
            </button>
          </td>
        </tr>
      );
    });

  return (
    <article id="file_index" className="file">
      <h1>{FILE_LIST_INDEX_TEXT}</h1>
      <div>
        <dl>
          <FileSelect
            file={file}
            fileName={fileName}
            setFile={setFile}
            setFileName={setFileName}
          />
          <button type="button" className="btn" onClick={onClickSubmit}>
            {UPLOAD}
          </button>
        </dl>
      </div>
      <div className="tablearea">
        <table className="fileindex_table" cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <th scope="col" className="sticky">
                {FILE_NAME_TEXT}
              </th>
              <th scope="col" className="sticky">
                {FILE_DATETIME_TEXT}
              </th>
              <th scope="col" className="sticky">
                {FILE_SPACE_TEXT}
              </th>
            </tr>
            {indexItem}
          </tbody>
        </table>
        {fileListIndex.length > parPage && (
          <Pagination
            limit={parPage}
            offset={offset}
            total={fileListIndex.length}
            onClick={(e, o) => handleClickPagination(o)}
          />
        )}
      </div>
    </article>
  );
};
export default FileListIndex;
